export default {
  methods: {
    formatDateTime(value, type) {
      if (value) {
        let val = value.toString();
        let date = `${val.substr(0, 4)}-${val.substr(4, 2)}-${val.substr(6, 2)}`;
        if (type == 'time') {
          return `${date} ${val.substr(8, 2)}:${val.substr(10, 2)}:${val.substr(12, 2)}`;
        } else {
          return date;
        }
      } else {
        return '';
      }
    }
  }
};
